import React, { useState, useContext } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { FormControl } from "@material-ui/core";
import { FormLabel } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { Select } from "@material-ui/core";
import { FormContext } from "../../util/context";
import { Button } from "@material-ui/core";

const Concussions = () => {
  const [form, setForm] = useContext(FormContext);
  const [concussion, setConcussion] = useState({});
  const handleChange = (event) => {
    setForm({ ...form, concussionNumber: event.target.value });
    console.log(event.target.value);
  };
  const onNext = () => {
    let concussionString = JSON.stringify(concussion);
    setForm({
      ...form,
      concussionHistory: concussionString,
      count: form.count + 1,
    });
    console.log(form.concussionHistory);
  };
  const recoveryTime = [
    "1 week",
    "2 weeks",
    "3 weeks",
    "4 weeks",
    "5 weeks",
    "6 weeks",
    "7 weeks",
    "8 weeks",
    "9 weeks",
    "10 weeks",
    "11 weeks",
    "12 weeks",
    "13 weeks",
    "14 weeks",
    "15 weeks",
    "16 weeks",
    "17 weeks",
    "18 weeks",
    "19 weeks",
    "20+ weeks",
  ];
  return (
    <>
      <Container maxWidth="xs">
        <Box paddingLeft={10}>
          <Typography align="center" component={"span"} variant="h4">
            Concussions
          </Typography>
        </Box>
      </Container>
      <Container maxWidth="sm">
        <Box mt={5}>
          <Container maxWidth="md">
            <FormControl size="medium">
              <Grid container={true} spacing={1}>
                <Grid item={true} xs={12}>
                  <FormLabel id="select">
                    How many Concussions have you received (diagnosed &
                    undiagnosed)?
                  </FormLabel>
                  <Select
                    fullWidth
                    variant="outlined"
                    id="select"
                    value={form.concussionNumber}
                    onChange={handleChange}
                  >
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                    <MenuItem value="6">6</MenuItem>
                    <MenuItem value="7">7</MenuItem>
                    <MenuItem value="8+">8+</MenuItem>
                  </Select>
                </Grid>

                {form.concussionNumber !== "0" && (
                  <>
                    {Array(parseInt(form.concussionNumber))
                      .fill()
                      .map((element, index) => {
                        return (
                          <Grid
                            container={true}
                            spacing={2}
                            key={`grid-${index}`}
                          >
                            <Grid
                              item={true}
                              xs={6}
                              key={`grid-item-year-${index}`}
                            >
                              <FormLabel
                                id={`form-${index}`}
                                key={`labelyear-${index}`}
                              >
                                Year Received Concussion #{index + 1}:
                              </FormLabel>
                              <FormControl fullWidth>
                                <Select
                                  key={`select=${index}`}
                                  fullWidth
                                  variant="outlined"
                                  id={`select-${index}`}
                                  defaultValue={(2000 - index).toString()}
                                  onChange={(event) => {
                                    let update = {};
                                    let key = "year" + (index + 1);
                                    update = { [key]: event.target.value };
                                    setConcussion({
                                      ...concussion,
                                      ...update,
                                    });
                                    console.log(concussion);
                                  }}
                                >
                                  {Array.from(
                                    Array(new Date().getFullYear() - 1949),
                                    (_, i) => (i + 1950).toString()
                                  ).map((element, index) => {
                                    return (
                                      <MenuItem
                                        key={index + element}
                                        value={element}
                                      >
                                        {element}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid
                              item={true}
                              xs={6}
                              key={`grid-item-time-${index}`}
                            >
                              <FormLabel
                                id={`recovery-${index}`}
                                key={`recov-${index}`}
                              >
                                Recovery Time Concussion #{index + 1}:
                              </FormLabel>
                              <FormControl fullWidth>
                                <Select
                                  key={`select=${index}`}
                                  fullWidth
                                  variant="outlined"
                                  id={`recovery-${index}`}
                                  defaultValue="2 weeks"
                                  onChange={(event) => {
                                    let update = {};
                                    let key = "recoveryTime" + (index + 1);
                                    update = { [key]: event.target.value };
                                    setConcussion({
                                      ...concussion,
                                      ...update,
                                    });
                                    console.log(concussion);
                                  }}
                                >
                                  {recoveryTime.map((element, index) => {
                                    return (
                                      <MenuItem
                                        key={index + element}
                                        value={element}
                                      >
                                        {element}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        );
                      })}
                  </>
                )}
                <Grid item={true} xs={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    onClick={onNext}
                  >
                    Next
                  </Button>
                </Grid>
              </Grid>
            </FormControl>
          </Container>
        </Box>
      </Container>
    </>
  );
};

export default Concussions;
